module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-189.1d00032.woff2";